<template>
  <el-card class="box-card" v-loading="isLoading">
    <div slot="header" class="clearfix">
      <span class="form-header">Indicador - Editar</span>
    </div>
    <div class="row">
      <div class="col">
        <el-form ref="form" :model="form" label-width="200px">
          <el-form-item label="Nome" prop="field" v-bind:error="errors.nome">
            <el-input v-model="form.nome" size="medium" autosize></el-input>
          </el-form-item>

          <el-form-item label="Superior" prop="parent_id" :error="errors.parent_id">
            <el-select v-model="form.parent_id" placeholder="Superior" clearable>
              <el-option
                v-for="item in indicadores"
                :key="item.id"
                :label="item.nome"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Unidade" prop="unidade" :error="errors.unidade">
            <el-select v-model="form.unidade_id" placeholder="Unidade">
              <el-option
                v-for="item in unidades"
                :key="item.id"
                :label="item.nome"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Requisito">
            <el-radio-group v-model="form.requisito_id" size="medium">
              <el-radio border :label="1">Maior Melhor</el-radio>
              <el-radio border :label="2">Menor Melhor</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="Fomula Descrição">
            <el-input v-model="form.formula" disabled></el-input>
          </el-form-item>
          <el-form-item label="Fomula Descrição">
            <el-input v-model="form.formula_macro" disabled></el-input>
          </el-form-item>
          <el-form-item label="Fórmula" v-show="isEditing" prop="formula_id" :error="errors.formula_id">
            <el-select v-model="form.formula_id" placeholder="Formula" clearable>
              <el-option
                v-for="item in formulas"
                :key="item.id"
                :label="item.nome"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item v-show="isEditing"
            v-for="n in quantidadePerguntas"
            :label="'Pergunta ' + n"
            :key="'pergunta_'+n">

            <el-select filterable v-model="form.perguntas[`p_${n}`]" placeholder="Pergunta">
              <el-option

                v-for="item in perguntas"
                :key="item.id"
                :label="item.descricao"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item align="right">
            <el-button type="danger" @click="excluir()">Excluir</el-button>
            <el-button type="warning" @click="toList()">Lista</el-button>
            <el-button type="danger" v-show="! isEditing" @click="isEditing = true">Editar</el-button>
            <el-button type="primary" @click="salvar" v-show="isEditing">Salvar</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </el-card>
</template>

<script>

  import {mapState} from 'vuex'

  export default {
    name: "indicador-show",
    data() {
      return {
        indicadores: [],
        formulas: [],
        requisitos: [],
        unidades: [],
        perguntas: [],
        errors: {},
        isLoading: false,
        isEditing: false,
        form: {
          perguntas: {}
        }
      }
    },
    computed: {
      id() {
        return this.$route.params.id
      }
      , quantidadePerguntas() {
        const formula = collect(this.formulas).firstWhere('id', this.form.formula_id)
        if (formula) {
          return collect(formula.macro.match(/p_./g) || []).unique().count()
        }
        return 0
      }

    },
    methods: {
      async salvar() {
        try {

          await axios.put(`${process.env.API_PATH}/indicador/${this.$route.params.id}`, this.form)
          this.$message({
            type: 'success',
            message: 'Atualizado  com sucesso!'
          });
        } catch (error) {
          this.$message({
            type: 'danger',
            message: 'Erro ao excluir contate o admisnistrador do sistema!'
          });
        }

      },
    toList() {
      this.$router.push({name: 'indicador.index'})
    },
      async excluir() {
        this.$confirm('Deseja excluir este registro?', 'Cuidado', {
          confirmButtonText: 'Sim',
          cancelButtonText: 'Não Excluir',
          type: 'warning'
        }).then(async () => {
          this.isProcessing = true
          try {
            await axios.delete(`${process.env.API_PATH}/indicador/${this.id}`)
            this.$message({
              type: 'success',
              message: 'Excluido com sucesso!'
            });
            this.listar()
          } catch (error) {
            this.$message({
              type: 'danger',
              message: 'Erro ao excluir contate o admisnistrador do sistema!'
            });
          }
          this.isProcessing = false
        }).catch(() => {
          this.$message({
            type: 'info',
            message: 'Ação Cancelada'
          });
        });
      },
      listar() {
        this.$router.push({name: 'indicador.index'})
      },
      async load() {
        try {
          this.isLoading = true
          const {data: {formulas, unidades, requisitos, perguntas,indicadores}} = await axios.get(`${process.env.API_PATH}/indicador/create`)
          this.indicadores = indicadores
          this.formulas = formulas
          this.unidades = unidades
          this.requisitos = requisitos
          this.perguntas = perguntas
          const {data} = await axios.get(`${process.env.API_PATH}/indicador/${this.$route.params.id}`)
          this.form = {...data , perguntas : {}}
        } catch (error) {
          console.log(error)
          this.$message({
            type: 'danger',
            message: 'Erro. Contate o admisnistrador do sistema!'
          });
        }
        this.isLoading = false
      }
    },
    async mounted() {
      await this.load()
    }

  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/features/Indicador/Show.vue